import PodcastSearchModal from './PodcastSearchModal';

export default PodcastSearchModal;
